import IndexTable from '@lib/components/index-table/IndexTable';
import GroupedProjectsTableRow from './GroupedProjectsTableRow';
import IndexTableHeading from '../index-table/IndexTableHeading';
import IndexTableFeature from '../index-table/IndexTableFeature';
import GroupedProjectsTableContext from './GroupedProjectsTableContext';
import shortid from 'shortid';
import React from 'react';
import * as _ from 'lodash';

export default class GroupedProjectsTable extends IndexTable {
    rowComponentClass = GroupedProjectsTableRow;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            expandedGroups: []
        }
    }

    render() {
        let rootCheckboxVisible = this.isMutliSelectTable();
        const RowComponent = this.rowComponentClass;
        const {options} = this.props;
        const columns = this.props.columns.filter(x => x.visible);
        const rootCheckboxId = 'root-checkbox-' + Math.random();
        const results = this.props.results;

        return (
            <table key={`group-${results.id}`} className="index-table">
                <thead>
                <tr>
                    <th></th>

                    {rootCheckboxVisible && <th className="table-checkbox-column">
                        <React.Fragment>
                            <input id={rootCheckboxId} type="checkbox" onChange={this.onRootCheckboxToggled}
                                   checked={this.state.isRootCheckboxChecked}/>
                            <label htmlFor={rootCheckboxId}></label>
                        </React.Fragment>
                    </th>}

                    {columns.map((column, idx) => (
                        <IndexTableHeading
                            key={idx}
                            column={column}
                            sortActive={this.isColumnSortActive(column)}
                            sortDirection={this.isColumnSortActive(column) ? this.getColumnSortDirection(column) : ''}
                            onClick={this.isSortableColumn(column.slug) ? () => this.onSortChange(column) : undefined}
                        />
                    ))}

                    {this.isFeatureRequested(IndexTableFeature.ActionButtons) && (
                        <th>{__('Actions')}</th>
                    )}
                </tr>
                </thead>

                <tbody>
                {results.map(result => (
                    <React.Fragment>
                        <RowComponent {...this.getRowComponentProps(result, columns, options)} />
                        {this.renderGroupedRows(result)}
                        {this.state.expandedGroups.includes(result.id) ? (
                            <React.Fragment>
                                {this.renderSpacer()}
                                {this.renderSpacer()}
                                {this.renderSpacer()}
                            </React.Fragment>
                        ) : (
                            <React.Fragment/>
                        )}
                    </React.Fragment>
                ))}
                </tbody>
            </table>
        )
    }

    onExpanderClick = (id) => {
        this.setState(prev => ({
            expandedGroups: _.xor(prev.expandedGroups, [id])
        }));
    }

    getRowComponentProps(result, columns, options) {
        var props = super.getRowComponentProps(result, columns, options);
        return {
            ...props,
            isGroupOpen: this.state.expandedGroups.includes(result.id),
            onExpanderClick: this.onExpanderClick
        }
    }

    renderSpacer = () => {
        const columns = this.props.columns.filter(x => x.visible);

        return (
            <tr key={shortid.generate()} className="index-table-spacer">
                <td></td>
                <td></td>

                {columns.map((x, idx) => (
                    <td key={idx}></td>
                ))}

                <td></td>
            </tr>
        )
    }

    renderGroupedRows = (row) => {
        const RowComponent = this.rowComponentClass;
        const columns = this.props.columns.filter(x => x.visible);
        const {options} = this.props;

        const showGroups = this.state.expandedGroups.includes(row.id);
        if (showGroups) {
            let projects = row.childs;
            if (projects.length === 0) {
                return this.renderSpacer();
            }

            return (
                <React.Fragment>
                    {projects.map(result => (
                        <RowComponent {...this.getRowComponentProps(result, columns, options)} isGroupItem={true}/>
                    ))}
                </React.Fragment>
            );
        }

        return <React.Fragment key={row.id + '_c'}></React.Fragment>;
    }
}
